import React from 'react';
import { colors } from '@keen.io/colors';
export var GRADIENT_ID = 'HOVER_BAR_MASK';
var Gradient = function (_a) {
    var _b = _a.color, color = _b === void 0 ? colors.black['500'] : _b;
    return (React.createElement("defs", null,
        React.createElement("linearGradient", { id: GRADIENT_ID, x1: "100%", x2: "0%", y1: "67.625%", y2: "67.625%" },
            React.createElement("stop", { offset: "0%", stopColor: color, stopOpacity: ".8" }),
            React.createElement("stop", { offset: "33.3%", stopColor: color, stopOpacity: ".1" }),
            React.createElement("stop", { offset: "66.6%", stopColor: color, stopOpacity: ".1" }),
            React.createElement("stop", { offset: "100%", stopColor: color, stopOpacity: ".8" }))));
};
export default Gradient;
